import React from 'react';
import PropTypes from "prop-types";
import styles from './block-list.css'

const BlockList = props => {
    const blockCategorizedMap = props.blockCategorizedMap;
    const categories = Object.keys(blockCategorizedMap).filter(category => !props.categoryBlackList.includes(category))
    return <div className={styles.blockListContainer}>
        {
            categories.map(blockCategory => {
                return <div data-category={blockCategory} className={styles.category}>
                    <h5>{blockCategory}</h5>
                    <div className={styles.blockList}>
                        {
                            blockCategorizedMap[blockCategory].map(blockInfo => {
                                const name = blockInfo.category;
                                const id = blockInfo.id;
                                const imgUrl = blockInfo.img;
                                const value = blockInfo.value;
                                const opcode = blockInfo.opcode;
                                return <label className={styles.blockOption}>
                                    <input type='checkbox'
                                           name={name}
                                           value={value}
                                           onChange={(e) => props.onSelect(blockInfo, e)}
                                           checked={props.value === opcode}
                                    />
                                    <img src={imgUrl} alt='pic' id={id} />
                                </label>
                            })
                        }
                    </div>
                </div>
            })
        }
    </div>
}

BlockList.propTypes = {
    value: PropTypes.string,
    categoryBlackList: PropTypes.array,
    onSelect: PropTypes.func.isRequired,
    blockCategorizedMap: PropTypes.object
};


BlockList.defaultProps = {
    categoryBlackList: [],
    blockList: [],
};

export default BlockList;
